<template>
    <Button color="default" class="hidden lg:inline-flex export-button" @click="openSetupExportModal">
        <slot>
            <icon icon="hero/outline/cloud-download" class="shrink-0 w-4 h-4 mr-3"></icon>

            {{ lang('general.datagrid.export') }}
        </slot>
    </Button>

    <ExportModal
        :show="setupExportModal"
        :url="url"
        :selected="selected"
        :filters="filters"
        :search="search"
        :has-active-filters="hasActiveFilters"
        :format-options="formatOptions"
        @close="closeSetupExportModal"
    />
</template>

<script setup lang="ts">
import { ref, toRef } from 'vue';
import ExportModal from './ExportModal.vue';

interface FormatOption {
    id: string;
    name: string;
}

const props = withDefaults(
    defineProps<{
        url: string;
        selected?: number[];
        formatOptions?: FormatOption[];
        filters?: object[];
        search?: string;
        hasActiveFilters?: boolean;
    }>(),
    {
        selected: () => [],
        formatOptions: () => [
            { id: 'xls', name: 'XLS' },
            { id: 'csv', name: 'CSV' },
            { id: 'json', name: 'JSON' },
            { id: 'xml', name: 'XML' },
        ],
        filters: () => [],
        search: '',
        hasActiveFilters: false,
    },
);

const formatOptions = toRef(props, 'formatOptions');

const setupExportModal = ref(false);

const openSetupExportModal = () => {
    setupExportModal.value = true;
};

const closeSetupExportModal = () => {
    setupExportModal.value = false;
};
</script>
